import { Action } from "../../../actions/actions";
import { VppsActionTypes } from "../actions/actionTypes";

export function creatingVpp(
    state: any = {
        values: {
            name: "",
            file: undefined,
            subsidiary: undefined
        },
        isValid: false
    },
    action: Action
) {
    const values =
        state && action.payload
            ? { ...state.values, ...action.payload.values }
            : action.payload
            ? action.payload.values
            : null;

    const isValid = state && action.payload ? action.payload.isValid : false;

    switch (action.type) {
        case VppsActionTypes.UPDATE_CREATING_VPP:
            return {
                values,
                isValid: isValid
            };

        case VppsActionTypes.CREATE_VPP_SUCCESS:
            return null;

        case VppsActionTypes.CREATE_VPP_RESET:
            return null;

        default:
            return state;
    }
}

export function creatingVppLoading(state: boolean = false, action: Action) {
    switch (action.type) {
        case VppsActionTypes.CREATE_VPP:
            return true;

        case VppsActionTypes.CREATE_VPP_SUCCESS:
        case VppsActionTypes.CREATE_VPP_FAIL:
            return false;

        default:
            return state;
    }
}
